import React from "react";

import { useAccount } from "@/api/accounts";
import Account, { type AccountProps } from "@/components/account";
import PlaceholderAccount from "@/features/placeholder/components/placeholder-account";

interface AccountContainerProps extends Omit<AccountProps, "account"> {
  id: string;
  withRelationship?: boolean;
}

const AccountContainer = ({
  id,
  withRelationship,
  ...props
}: AccountContainerProps) => {
  const { account, isInitialLoading } = useAccount(id, { withRelationship });

  if (isInitialLoading) {
    return <PlaceholderAccount />;
  }

  return (
    <Account
      account={account!}
      withRelationship={withRelationship}
      {...props}
    />
  );
};

export default AccountContainer;
